import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseResponse } from '../models/base-response.model';
import { UserOptionModel } from '../shared/models/user-option.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }

  public deleteUserOption(optionId: number) {
    return this.httpClient.delete(`/users/deleteUserOption/${optionId}`);
  }
  public editUserOption(option: any) {
    return this.httpClient.put(`/users/EditUserOption`, option);
  }
  public getUser(userId: number) {
    return this.httpClient.get(`/users/GetUser/${userId}`);
  }
  public getVendors() {
    return this.httpClient.get(`/vendors`);
  }
  public getCoreUserGroups() {
    return this.httpClient.get<BaseResponse<any>>(
      "/EskaCoreIntegrationApi/GetAllGroups"
    );
  }
  public getCoreUsers() {
    return this.httpClient.get<BaseResponse<any>>(
      "/EskaCoreIntegrationApi/GetAllUsers"
    );
  }

  public getUserWallet(id){
    return this.httpClient.get(
      `/LoyaltyWallet/UserWallet/${id}`
    );
  }

  public suspendUserWallet(id){
    return this.httpClient.post(
      `/LoyaltyWallet/SuspendUserWallet/${id}`,{}
    );
  }
  public activeUserWallet(id){
    return this.httpClient.post(
      `/LoyaltyWallet/ActiveUserWallet/${id}`,{}
    );
  }
}
